module.exports = __webpack_public_path__ + "img/05-Pic-01.ba0b64b4.png";